import { Brain, Heart, Moon, Zap, Sparkles, Pause, Dumbbell, Trophy } from 'lucide-react';

export interface Category {
  id: string;
  name: string;
  description: string;
  color: string;
  icon: any;
  samplePrompt?: string;
}

// 8 Core Categories - Simple and Clean
export const categories: Category[] = [
  {
    id: 'meditation',
    name: 'Meditation',
    description: 'Traditional guided meditation practices for mindfulness and inner peace • You\'ll feel centered, calm, and more present • 5-20 minutes',
    color: 'from-blue-400 to-teal-600',
    icon: Brain,
    samplePrompt: 'Create a 10-minute guided meditation focused on breath awareness and mindfulness.'
  },
  {
    id: 'anxiety',
    name: 'Anxiety Relief',
    description: 'Calming sessions to reduce stress and manage anxiety • You\'ll feel more relaxed, grounded, and in control • 5-15 minutes',
    color: 'from-blue-400 to-blue-600',
    icon: Heart,
    samplePrompt: 'Create a 10-minute anxiety relief session using breathing techniques and calming visualization.'
  },
  {
    id: 'sleep',
    name: 'Sleep',
    description: 'Relaxing content to help you fall asleep peacefully • You\'ll drift off naturally and sleep more deeply • 10-30 minutes',
    color: 'from-indigo-400 to-purple-600',
    icon: Moon,
    samplePrompt: 'Create a 15-minute sleep meditation with progressive muscle relaxation.'
  },
  {
    id: 'motivation',
    name: 'Motivation',
    description: 'Energizing sessions to boost confidence and drive • You\'ll feel empowered, focused, and ready to take action • 5-15 minutes',
    color: 'from-orange-400 to-red-600',
    icon: Zap,
    samplePrompt: 'Create a 10-minute motivational session to boost confidence and energy.'
  },
  {
    id: 'memory',
    name: 'Memory Enhancement',
    description: 'Techniques to improve focus and cognitive function',
    color: 'from-green-400 to-teal-600',
    icon: Brain,
    samplePrompt: 'Create a 10-minute memory enhancement session using visualization and cognitive exercises.'
  },
  {
    id: 'massage',
    name: 'Body Relaxation',
    description: 'Guided sessions for self-massage and body awareness',
    color: 'from-pink-400 to-rose-600',
    icon: Sparkles,
    samplePrompt: 'Create a 10-minute guided self-massage session for relaxation and tension relief.'
  },
  {
    id: 'be_still',
    name: 'Emotional Reset',
    description: 'Moments of stillness and quiet contemplation',
    color: 'from-gray-400 to-gray-600',
    icon: Pause,
    samplePrompt: 'Create a 10-minute stillness session focused on inner quiet and peace.'
  },
  {
    id: 'self_love',
    name: 'Self Love',
    description: 'Practices for self-acceptance and inner compassion',
    color: 'from-rose-400 to-pink-600',
    icon: Heart,
    samplePrompt: 'Create a 10-minute self-love session with affirmations and compassion practices.'
  },
  {
    id: 'fitness',
    name: 'Fitness & Workout Motivation',
    description: 'High-energy motivation for workouts and mental strength',
    color: 'from-orange-500 to-red-600',
    icon: Dumbbell,
    samplePrompt: 'Create a 10-minute high-energy fitness motivation session for pre-workout pump-up and mental strength building.'
  },
  {
    id: 'life_celebrations',
    name: 'Life Celebrations',
    description: 'Honor and amplify life\'s special moments with guided celebration sessions',
    color: 'from-yellow-400 to-orange-500',
    icon: Trophy,
    samplePrompt: 'Create a 10-minute celebration session to amplify joy and gratitude for special life moments and achievements.'
  },
  {
    id: 'zen-af',
    name: 'ZEN AF',
    description: 'Raw, explicit meditation for releasing frustration and stress (18+ only)',
    color: 'from-red-500 to-red-700',
    icon: Heart,
    samplePrompt: 'Create a personalized meditation session that uses raw language therapeutically to validate frustrations and guide to empowerment.'
  }
];

// Export alias for backward compatibility
export const advancedCategories = categories;
